// extracted by mini-css-extract-plugin
export var defaultWrapper = "_jv-3";
export var downloadButton = "_jv-4";
export var fileContainer = "_jv-9 _jv-7";
export var fileContainerBase = "_jv-7";
export var fileContainerBaseSm = "_jv-a _jv-7";
export var fileContainerFixedHeight = "_jv-8 _jv-7";
export var fileContainerFixedHeightSm = "_jv-c _jv-a _jv-7";
export var fileContainerSm = "_jv-b _jv-a _jv-7";
export var fileInfo = "_jv-5";
export var fileInfoWidthRestricted = "_jv-6";
export var fileType = "_jv-1";
export var fileTypeName = "_jv-2";
export var fileTypeSm = "_jv-d _jv-1";
export var image = "_jv-0";
export var link = "_jv-f";
export var overflowEllipsis = "_jv-e";